import React from "react";
import bgImg from "../../asset/Ellipse 3.png";
import mobileImg from "../../asset/mobile img.png";
import { useInView } from "react-intersection-observer";
import { NavLink } from "react-router-dom";

const Complaint = () => {
  const { ref: refOne, inView: inViewOne } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const { ref: refTwo, inView: inViewTwo } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <div className="xl:py-20 lg:py-16 py-12">
      <div className="flex justify-between md:flex-row flex-col items-center xl:gap-8 lg:gap-6 md:gap-4 gap-8 xl:px-[5%] lg:px-[3%] md:px-[2%] px-[6%]">
        <div
          ref={refOne}
          className={`flex-1  flex flex-col items-start lg:gap-6 md:gap-4 gap-3 ${
            inViewOne ? "animate-slideRight" : "opacity-0"
          }`}
        >
          <span className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[2rem] font-bold">
            Lodge a Complaint
          </span>
          <span className="xl:text-[1.2rem] lg:text-[1rem] md:text-[.9rem] text-[1rem] text-[#7A7A7A]">
            RDA aims digitalization specifically for overseas complainants. Any citizen aggrieved with any action can remotely reach out to RDA through Digital Complaint Management System.
          </span>
          <div className="flex items-center gap-3">
            <NavLink
              to={"/contact-us"}
              className="px-3 py-2 rounded-xl bg-transparent border border-[#00643B] hover:bg-[#00643B]  hover:text-white  font-semibold text-[#00643B]"
            >
              Contact Us
            </NavLink>
            <NavLink
              to={`https://cms.rda.gop.pk/`}
              className="px-3 py-2 rounded-xl bg-[#00643B] border border-[#00643B] hover:text-[#00643B]  hover:bg-transparent font-semibold text-white"
            >
              Lodge a Complaint
            </NavLink>
          </div>
        </div>
        <div className=" flex-1 ">
          <div className="w-full h-full flex md:justify-end justify-center relative ">
            <img src={bgImg} className="w-[90%]" alt="" />

            <img
              ref={refTwo}
              src={mobileImg}
              alt=""
              className={`absolute w-[40%] md:right-[25%] right-[30%] top-[4%] transition-[width,top] duration-300 ease-in-out 
    hover:w-[43%] hover:top-[2%] ${
      inViewTwo ? "animate-slideUp" : "opacity-0"
    }`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Complaint;
